import { mapState, mapGetters } from 'vuex';
import {
  SWITCH_SERVER,
  UPDATE_ROLE_LIST,
  UPDATE_PC_SERVER_ID,
  UPDATE_LOADING,
  SET_SHOW_CHANNEL_STATUS,
  SET_HAS_LOAD_PAYTYPE,
  UPDATE_HAS_SELECT_PRODUCT,
  SWITCH_ROLE,
  UPDATE_ROLE_NAME,
  GET_ROLE_LIST,
  UPDATE_PRODUCT_LIST,
  GET_PRODUCT_LIST,
  UPDATE_PRODUCT_TYPES,
  GET_SERVER_LIST
} from '@store/officialStore';
import {
  UPDATE_UID,
  UPDATE_UID_TOKEN_LOGIN_STATUS,
  UPDATE_UID_LOGIN_STATUS,
  UID_LOGIN,
  LOGOUT
} from '@store/officialStore/login';
import { UPDATE_IS_CART, CLEAR_CART } from '@store/officialStore/cart';
import globalConfig from '@utiles/officialStore/globalConfig';
import { initViewport } from '@utiles/officialStore/index';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV1';
import { updateCommonParamsInfo } from '@plugins/biPoint/commonParam';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';

const MAIN_HOST = globalConfig.getMainHost();

export default {
  computed: {
    ...mapState({
      isLogin: state => state.login.isLogin,
      isUidLogin: state => state.login.isUidLogin,
      isUidTokenLogin: state => state.login.isUidTokenLogin,
      isUidTypeAndHideVipCoupon: state => state.login.isUidTypeAndHideVipCoupon,
      letter: state => state.letter,
      serverList: state => state.serverList,
      serverId: state => state.serverId,
      roleId: state => state.roleId,

      gameId: state => state.gameId,
      pcServerId: state => state.pcServerId,
      roleName: state => state.roleName,
      uid: state => state.login.uid,
      loginAccount: state => state.login.loginAccount
    }),
    ...mapGetters(['isJpPlatform', 'gameInfoConfig']),
    serverId: {
      get() {
        let sid = this.$store.state.serverId || 0;
        if (this.serverList == null) {
          return sid;
        }

        return sid;
      },
      set(id) {
        this.$store.commit(SWITCH_SERVER, id);
        this.$store.commit(UPDATE_PC_SERVER_ID, this.getCurSid(id));
      }
    },
    roleId: {
      get() {
        return this.serverId === 0 ? -1 : this.$store.state.roleId || -1;
      },
      set(id) {
        this.$store.commit(SWITCH_ROLE, id);
        this.$store.commit(UPDATE_ROLE_NAME, this.getCurRoleName(id));
      }
    },
    getCurLastedServerName() {
      let res = '';
      if (!this.serverList || this.lastedGame != this.gameId) return res;
      for (let i in this.serverList) {
        if (this.serverList[i].ID == this.lastedServerId) {
          res = this.serverList[i].NAME;
          break;
        }
      }
      return res;
    }
  },
  methods: {
    resetStatus() {
      this.$store.commit(UPDATE_HAS_SELECT_PRODUCT, false);
      this.$store.commit(UPDATE_IS_CART, false);
      this.$store.commit(CLEAR_CART);
      this.$store.commit(SET_SHOW_CHANNEL_STATUS, false);
      this.$store.commit(SET_HAS_LOAD_PAYTYPE, false);
    },

    handleUidLogin() {
      clickButton({
        btnName: 'login-way-uid'
      });
      this.$store.commit(UPDATE_UID_LOGIN_STATUS, true);
    },
    handleUidTokenLogin() {
      clickButton({
        btnName: 'login-way-token'
      });
      this.$store.commit(UPDATE_UID_TOKEN_LOGIN_STATUS, true);
    },
    login() {
      clickButton({
        btnName: 'login-way-sns'
      });
      this.doLogin({
        gameId: this.gameId,
        serverId: this.serverId,
        roleId: this.roleId,
        pcServerId: this.pcServerId
      });
    },
    doLogin({ gameId, serverId, roleId, pcServerId }) {
      const p = globalConfig.getHrefParam('p');
      let extendInfo = '';
      // 虽然默认没有是undefined。但computed中有处理，serverId没有的时候是0，roleId没有的时候是-1
      if (serverId != undefined && serverId !== 0) {
        extendInfo += `&server_id=${serverId}`;
      }
      if (pcServerId) {
        extendInfo += `&serverId=${pcServerId}`;
      }
      if (roleId != undefined && roleId !== -1) {
        extendInfo += `&roleId=${roleId}`;
      }
      // 2021-10-21 添加其他参数传递
      let hrefSearch = window.location.search.substring(1);
      let realHref = `https://pay.${MAIN_HOST}/platform/login.html?${
        gameId ? `gameId=${gameId}&` : ''
      }${p ? `p=${p}&` : ''}forward=${encodeURIComponent(
        getGlobalGetGotoLink({
          link: `https://pay.${MAIN_HOST}/platform/officialStore.html?${
            gameId ? `gameId=${gameId}` : ''
          }${extendInfo ? `${gameId ? '&' : ''}${extendInfo}` : ''}${
            hrefSearch ? `${gameId || extendInfo ? '&' : ''}${hrefSearch}` : ''
          }`
        })
      )}`;
      window.location.href = getGlobalGetGotoLink({ link: realHref });
    },
    goLogOut() {
      clickButton({
        btnName: 'logout',
        locationKey: locationType.accountInfo
      });
      this.$store.dispatch(LOGOUT).then(() => {
        window.location.reload();
      });
    },
    handleSwitchWay() {
      if (this.isLogin) {
        this.goLogOut();
      } else {
        this.$store.commit(UPDATE_UID_LOGIN_STATUS, false);
      }
    },
    doUidLogin() {
      clickButton({
        btnName: 'login-way-uid-confirm'
      });
      if (!this.uid) {
        alert(this.letter.storeInputId);
        return;
      }
      this.$store.commit(UPDATE_LOADING, true);
      this.$store
        .dispatch(UID_LOGIN, {
          uid: this.uid,
          gameId: this.gameId,
          language: this.lang
        })
        .then(({ result }) => {
          if (result) {
            this.$store.commit(SWITCH_SERVER, 0);
            this.$store.commit(UPDATE_PC_SERVER_ID, 0);
            this.$store.commit(UPDATE_ROLE_LIST, []);
            this.$store.dispatch(GET_SERVER_LIST).then(_serverList => {
              this.$store.commit(UPDATE_LOADING, false);
            });
          }
        })
        .catch(({ msg }) => {
          this.$store.commit(UPDATE_LOADING, false);
          this.$store.commit(SWITCH_SERVER, 0);
          this.$store.commit(UPDATE_PC_SERVER_ID, 0);
          this.$store.commit(UPDATE_ROLE_LIST, []);
          alert(msg);
        });
    },
    updateUid(id) {
      if (id !== this.uid) {
        let curId = String(id).replace(/[^\d]*/g, '');
        this.$store.dispatch(UPDATE_UID, curId);
      }
    },
    getCurSid(id) {
      let res = id;
      if (!id) return res;
      for (let i in this.serverList) {
        if (this.serverList[i].ID == id) {
          res = this.serverList[i].SID;
          break;
        }
      }
      return res;
    },
    getCurRoleName(id) {
      let res = '';
      if (!this.roleList) return res;
      for (let i in this.roleList) {
        if (this.roleList[i].roleID == id) {
          res = this.roleList[i].roleName;
          break;
        }
      }
      return res;
    },
    loadRole(selectReason) {
      this.resetStatus();
      this.$store
        .dispatch(GET_ROLE_LIST, this.serverId)
        .then(({ loadProductRightNow, roleId }) => {
          if (loadProductRightNow && roleId != null) {
            this.$store.dispatch(GET_PRODUCT_LIST);
            updateCommonParamsInfo({
              roleId: this.roleId,
              roleName: this.roleName,
              serverId: this.serverId
            });
            window.webstorev1DataLayer.push({
              eventName: 'bind',
              eventValue: {
                role_id: this.roleId,
                role_name: this.roleName,
                server_id: this.serverId
              },
              eventReason: selectReason || ''
            });
            if (this.gameInfoConfig.isBlackFridayVersion) {
              try {
                window.__updatePointUploadCookie('server_id', this.serverId);
                window.__updatePointUploadCookie('role_id', this.roleId);
                window.__updatePointUploadCookie('role_name', this.roleName);
              } catch (error) {
                console.error(error);
              }
            }
          }
        });
      this.$store.commit(UPDATE_PRODUCT_LIST, []);
      this.$store.commit(UPDATE_PRODUCT_TYPES, []);
    },
    initViewport
  }
};
